import { createFileRoute } from "@tanstack/react-router";
import SkodaHub from "@/pages/hub/SkodaHub";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/hub/skoda/")({
  head: () => routeHead("/hub/skoda/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SkodaHub />
  );
}
